module.exports = __webpack_public_path__ + "img/spiceblends.40d3715a.jpg";